const k_products = [
    {
        "type": "cleanser",
        "skin_type": "oil",
        "name": "skinfood gel cleanser",
        "info": "A delicious daily gel cleanser with a lush blend of bio-active ingredients, including papaya, guava, cucumber & mango extracts to cleanse & rejuvenate your skin - cleansing never smelt so good!",
        "ingredients": "Aqua (Water), Glycerin (Vegetable), Cocamidopropyl Betaine, Coco-Glucoside, Glyceryl Oleate, Sclerotium Gum, Xanthan Gum, Gluconolactone, Sodium Benzoate, Caprylyl/Capryl Glucoside, Psidium Guajava (Guava) Fruit Extract, Carica Papaya (Papaya) Fruit Extract, Cucumis Sativus (Cucumber) Extract*, Mangifera Indica (Mango) Extract, Parfum (Natural Fragrance), Sodium Citrate, Limonene**. 99.02% of the total ingredients are from natural origin.",
        "image": "/images/cleansers/skinfood-cleanser.jpg",
        "price": 13.99,
        "qty": 1,
        "id": 1,
    },
    {
        "type": "cleanser",
        "skin_type": "sensitive",
        "name": "COSRX Low pH Good Morning",
        "info": "Low pH Good Morning Gel Cleanser: With a mildly acidic pH level, this cleanser is highly effective in cleansing excess sebum on the skin without irritating or drying out your skin.",
        "ingredients": "Ingredients Water, Cocamidopropyl Betaine, Sodium Lauroyl Methyl Isethionate, Polysorbate 20, Styrax Japonicus Branch/Fruit/Leaf Extract, Butylene Glycol, Saccharomyces Ferment, Cryptomeria Japonica Leaf Extract, Nelumbo Nucifera Leaf Extract, Pinus Palustris Leaf Extract, Ulmus Davidiana Root Extract, Oenothera Biennis (Evening Primrose) Flower Extract, Pueraria Lobata Root Extract, Melaleuca Alternifolia (Tea Tree) Leaf Oil, Allantoin, Caprylyl Glycol, Ethylhexylglycerin, Betaine Salicylate, Citric Acid, Ethyl Hexanediol, 1,2-Hexanediol, Trisodium Ethylenediamine Disuccinate, Sodium Benzoate, Disodium EDTA",
        "image": "/images/cleansers/cosrx-cleanser.jpg",
        "price": 9.45,
        "qty": 1,
        "id": 2,
    },
    {
        "type": "cleanser",
        "skin_type": "sensitive",
        "name": "Dear, Klairs Rich Moist Foaming Cleanser",
        "info": "Acid balanced cleanser will help retain your skin’s moisture level after the facial wash. This hypoallergenic face wash contains low irritant exfoliating ingredient for sensitive skin so that you can feel smooth skin texture afterwards.",
        "ingredients": "Glycerine, Potassium hydroxide, Beta glucan, Panthenol, Licorice, Olive oil, Citric acid, Fruit oil, Sodium, Tea-tree, Hyaluronic-acid, Stearic acid, Aloe vera, Ginseng.",
        "image": "/images/cleansers/klairs-s-cleanser.jpg",
        "price": 14.4,
        "qty": 1,
        "id": 3,
    },
    {
        "type": "cleanser",
        "skin_type": "combination",
        "name": "tony moly green tea cleanser",
        "info": "Gently deep clean skin with this natural foam cleanser. Infused with Pure Fermented Green Tea Extract, to hydrate and refresh the skin. Featuring a rich foam lather, this cleanser is perfect for everyday use! ",
        "ingredients": "Water, Myristic Acid, Glycerin, Potassium Hydroxide, Lauramide DEA, Lauric Acid, Stearic Acid, Cocamidoprophyl Betaine, Glyceryl Stearate, Glycol Distearate, Camellia Sinensis Leaf Extract, Beeswax, Trihydroxystearin, Polysorbate 20, PEG-200, PEG-100 Stearate, Polyquaternium-7, Sodium Chloride, Tetrasodium EDTA, Tocopheryl Acetate, Citrus Limon (Lemon) Seed Oil, Aniba Rosaeodora (Rosewood) Wood Oil, Phenoxyethanol, Ethylhexylglycerin",
        "image": "/images/cleansers/tony-cleanser.jpg",
        "price": 14,
        "qty": 1,
        "id": 4,
    },
    {
        "type": "cleanser",
        "skin_type": "All skin types",
        "name": "Dr. Jart+ - Dermaclear Micro Foam",
        "info": "This micro foam cleanser refreshes & purifies skin with a rich, creamy lather! Powered by Dr.Jart’s proprietary Hydrogen Bio Water™ deeply cleanses pores + removes makeup residue. Mineral-rich Dead Sea Salt helps purify skin as Coconut Water gently softens + lightly moisturizes for comfortably clean skin.",
        "ingredients": "Water, Myristic Acid, Sorbitol, Butylene Glycol, Stearic Acid, Potassium Hydroxide, Glycerin, Lauric Acid, Potassium Cocoyl Glycinate, Glycol Distearate, Polysorbate 20, Cocamidopropyl Betaine, Glyceryl Stearate, PEG-32, PEG-7 Glyceryl Cocoate, PEG-100 Stearate, Potassium Cocoate, Polyquaternium-7, Phenoxyethanol, Citrus Aurantium Bergamia (Bergamot) Fruit Oil, Pelargonium Graveolens Flower Oil, Disodium EDTA, Citrus Limon (Lemon) Peel Oil, Ethylhexylglycerin, Olea Europaea (Olive) Fruit Oil, Sodium Benzoate, Panthenol, Salvia Officinalis (Sage) Oil, Dipropylene Glycol, Pogostemon Cablin Oil, Sodium Palmitoyl Proline, Pinus Sylvestris Leaf Oil, Citrus Aurantium Dulcis (Orange) Oil, Citrus Grandis (Grapefruit) Peel Oil, Salvia Sclarea (Clary) Oil, Aniba Rosaeodora (Rosewood) Wood Oil, Rosmarinus Officinalis (Rosemary) Leaf Extract, Nymphaea Alba Flower Extract, Lavandula Angustifolia (Lavender) Oil, Cedrus Atlantica Bark Oil, Eucalyptus Globulus Leaf Oil, Anthemis Nobilis Flower Extract, Copaifera Officinalis (Balsam Copaiba) Resin, Citrus Aurantifolia (Lime) Fruit Extract, Salvia Officinalis (Sage) Leaf Extract, Jasminum Officinale (Jasmine) Oil, Myrtus Communis Oil, Artemisia Absinthium Extract, Rose Flower Oil, Vanilla Planifolia Fruit Extract, Ferula Galbaniflua (Galbanum) Resin Oil.",
        "image": "/images/cleansers/djart-all-cleanser.jpg",
        "price": 18.99,
        "qty": 1,
        "id": 5,

    },
    {
        "type": "cleanser",
        "skin_type": "All skin types",
        "name": "banila co clean it zero",
        "info": "bestselling Clean It Zero Original was created to quickly and easily melt away even the most stubborn face & eye makeup. Designed with all skin types in mind, this skin-loving formula, completely cleanses skin and hydrates in one simple step. The perfect first step in your double-cleansing routine!",
        "ingredients": "Ethylhexyl Palmitate, Cetyl Ethylhexanoate, PEG-20 Glyceryl Triisostearate, PEG-10 Isostearate, Synthetic Wax, Onsen-Sui, Phenoxyethanol, Butylene Glycol, Lithospermum Erythrorhizon Root Extract, Tocopheryl Acetate, Fragrance, Ethylhexylglycerin, Water, 1,2-Hexanediol, Bambusa Vulgaris Leaf/Stem Extract, Aspalathus Linearis Extract, Angelica Archangelica Root Extract, Malpighia Glabra (Acerola) Fruit Extract, Polydiethyleneglycol Adipate/IPDI Copolymer, Acrylates/Ammonium Methacrylate Copolymer, Acrylates/Methoxy PEG-15 Methacrylate Copolymer",
        "image": "/images/cleansers/banila-cleanser.jpg",
        "price": 18.36,
        "qty": 1,
        "id": 6,

    },
    {
        "type": "cleanser",
        "skin_type": "All skin types",
        "name": "The Face Shop Rice Water Bright Foam Cleanser",
        "info": "This gently, brightening cleansing foam enriched with rice extracts offers your skin clear and even complexion. Enriched with a natural rice water solution with brightening properties, it cleanses skin without irritation, thanks to its creamy texture.",
        "ingredients": "WATER/EAU•MYRISTIC ACID•GLYCERIN•POTASSIUM HYDROXIDE•STEARIC ACID•GLYCOL DISTEARATE•LAURIC ACID•COCAMIDOPROPYL BETAINE•COCAMIDE MEA•DISODIUM COCOAMPHODIACETATE•GLYCERYL STEARATE•PEG-100 STEARATE•SODIUM LAURYL SULFATE•ORYZA SATIVA (RICE) EXTRACT•SAPONARIA OFFICINALIS LEAF EXTRACT•ORYZA SATIVA (RICE) BRAN OIL•TITANIUM DIOXIDE (CI 77891)•SODIUM CHLORIDE•DIVINYLDIMETHICONE/DIMETHICONE COPOLYMER•C12-13 PARETH-23•C12-13 PARETH-3•HEXYLENE GLYCOL•DISODIUM EDTA•BLUE 1 (CI 42090)•YELLOW 5 (CI 19140)•RED 4 (CI 14700)•HYDROXYPROPYL METHYLCELLULOSE•PARFUM/FRAGRANCE",
        "image": "/images/cleansers/faceshop-all-cleanser.jpg",
        "price": 11.97,
        "qty": 1,
        "id": 7,

    },
    
    {
        "type": "cleanser",
        "skin_type": "dry",
        "name": "Missha Super Off Cleansing Oil",
        "info": "This multi-tasking cleanser uses natural oils, including argan oil and sweet almond oil to deeply moisturize and effectively melt away heavy makeup and impurities. Nourishing ingredients like shea butter provide extra hydrating benefits. The gentle, non-irritating formula is free of mineral oil, synthetic fragrance and parabens.",
        "ingredients": "Helianthus Annuus (Sunflower) Seed Oil, Triethylhexanoin, Ethylhexyl Stearate, Polybutene, Peg-20 Glyceryl Triisostearate, Ethylhexyl Palmitate, Prunus Amygdalus Dulcis (Sweet Almond) Oil, Isononyl Isononanoate, Isopropyl Myristate, Caprylic/capric Triglyceride, 1,2-Hexanediol, Lavandula Angustifolia (Lavender) Oil, Pentaerythrityl Tetra-di-t-butyl, Hydroxyhydrocinnamate, Argania Spinosa Kernel Oil, Anthemis Nobilis Flower Oil, Butyrospermum Parkii (Shea) Butter",
        "image": "/images/cleansers/missha-d-cleanser.jpg",
        "price": 38,
        "qty": 1,
        "id": 8,

    },
    // tonners
    {
        "type": "toner",
        "skin_type": "All skin types",
        "name": "skinfood tomato whitening toner",
        "info": "Brighten up with the Tomato Brightening Toner! Containing 10% tomato extract, vitamin-C derivatives, & niacinamide, this toner softens and helps to brighten for a clear and even complexion.",
        "ingredients": "Water, Solanum Lycopersicum (Tomato) Fruit Extract, Dipropylene Glycol, Niacinamide, Glycereth-26, Glycerin, Beta-Glucan, Polysorbate 80, Sodium Citrate, 3-O-Ethyl Ascorbic Acid, Citric Acid, Glyceryl Acrylate/Acrylic Acid Copolymer, Sodium Palmitoyl Proline, Nymphaea Alba Flower Extract, Sodium Phytate, 1, 2-Hexanediol,",
        "image": "/images/toners/skinfood-toner.png",
        "price": 21,
        "qty": 1,
        "id": 20,
    },
    {
        "type": "toner",
        "skin_type": "combination",
        "name": "Isntree Hyaluronic Acid Toner",
        "info": "sntree Hyaluronic acid toner is formulated with non-irritating, natural ingredients, providing all day and night long moisturization. Helps to restore. The hydrating formula will be absorbed deeply through the layer of skin in seconds without clogging pores or heavy feeling.",
        "ingredients": "Water, Propanediol, 1,2-Hexanediol, Sodium Hyaluronate, Trehalose, Sodium PCA, Glycerin, Hyaluronic Acid, Aloe Barbadensis Leaf Extract, Althaea Rosea Root Extract, Betula Alba Juice, Portulaca Oleracea Extract, Hydrolyzed Sodium Hyaluronate, Beta-Glucan, Panthenol, Pentylene Glycol, Caprylyl Glycol, Butylene Glycol",
        "image": "/images/toners/isntree.png",
        "price": 13.2,
        "qty": 1,
        "id": 21,
    },
    {
        "type": "toner",
        "skin_type": "sensitive",
        "name": "klairs - Supple Preparation Facial Toner",
        "info": "Balances the skin’s pH level and improves the effectiveness of your entire skincare regime, helping you to achieve your best skin. Enhance the effectiveness of serums and creams with the Klairs Supple Preparation Facial Toner that balances your skin’s natural pH levels, creating the perfect canvas for your skin care products.",
        "ingredients": "Water, Butylene Glycol, Dimethyl Sulfone, Betaine, Caprylic/Capric Triglyceride, Natto Gum, Sodium Hyaluronate, Disodium EDTA, Centella Asiatica Extract, Glycyrrhiza Glabra (Licorice) Root Extract, Polyquaternium-51, Chlorphenesin, Tocopheryl Acetate, Carbomer, Panthenol, Arginine, Luffa Cylindrica Fruit/Leaf/Stem Extract, Beta-Glucan, Althaea Rosea Flower Extract, Aloe Barbadensis Leaf Extract, Hydroxyethylcellulose, Portulaca Oleracea Extract, Lysine HCL, Proline, Sodium Ascorbyl Phosphate, Acetyl Methionine, Theanine, Lavandula Angustifolia (Lavender) Oil, Eucalyptus Globulus Leaf Oil, Pelargonium Graveolens Flower Oil, Citrus Limon (Lemon) Peel Oil, Citrus Aurantium Dulcis (Orange) Peel Oil, Cananga Odorata Flower Oil, Copper Tripeptide-1, Linalool, Limonene",
        "image": "/images/toners/klairs-dry.jpg",
        "price": 23,
        "qty": 1,
        "id": 22,
    },
    {
        "type": "toner",
        "skin_type": "sensitive",
        "name": "Benton Aloe BHA Toner",
        "info": "Packed with skin-benefitting ingredients such as aloe and salicylic acid, this toner hydrates and preps your skin to help with the absorption of skincare products in the next step in your routine.",
        "ingredients": "Aloe Barbadensis Leaf Water, Aqua(Water), Butylene Glycol, lycerin, 1,2-Hexanediol, Sodium Hyaluronate, Snail Secretion Filtrate, Beta-Glucan, Polyglutamic Acid, Aspalathus Linearis Extract, Portulaca Oleracea Extract, Psidium Guajava Fruit Extract, Salicylic Acid, Althaea Rosea Root Extract, Aloe Barbadensis Leaf Extract, Aloe Barbadensis Leaf Juice, Arginine, Pentylene Glycol, Zanthoxylum Piperitum Fruit Extract, Pulsatilla Koreana Extract, Usnea Barbata (Lichen) Extract, Polysorbate 20, Acrylates/C10-30 Alkyl Acrylate Crosspolymer, Xanthan Gum",
        "image": "/images/toners/benton.jpg",
        "price": 19,
        "qty": 1,
        "id": 23,
    },
    {
        "type": "toner",
        "skin_type": "oil",
        "name": "Etude House Wonder Pore Freshner",
        "info": "Pore care product that prevents and shrinks enlarged pores, firms skin, and eliminates harmful bacterium from forming under skin. It solves multiple skin care troubles at once with its patented formula. Cinnamon, Lotus and, germanium extracts control excessive sebum while vegetable ingredients refine skin tone. Take control of your pores today!",
        "ingredients": "WATER, ALCOHOL, BUTYLENE GLYCOL, BETAINE, MENTHA ARVENSIS EXTRACT, VACCINIUM MYRTILLUS FRUIT/ LEAF EXTRACT, SACCHARUM OFFICINARUM (SUGAR CANE) EXTRACT, CITRUS MEDICA LIMONUM (LEMON) FRUIT EXTRACT, CITRUS AURANTIUM DULCIS (ORANGE) FRUIT EXTRACT, CHAM- AECYPARIS OBTUSA WATER, GINKGO BILOBA LEAF EXTRACT, ACER SACCHARUM (SUGAR MAPLE) EXTRACT, GENTIANA LU- TEA ROOT EXTRACT, ARTEMISIA ABSINTHIUM EXTRACT, ARNICA MONTANA FLOWER EXTRACT, ACHILLEA MILLEFOLIUM EXTRACT, GLYCERETH-26, GLYCERIN, ETHYLHEXYLGLYCERIN, SODIUM HYALURONATE, ACETIC ACID, DISODIUM EDTA, PHENOXYETHANOL",
        "image": "/images/toners/etude-house.jpg",
        "price": 12.45,
        "qty": 1,
        "id": 24,
    },
    {
        "type": "toner",
        "skin_type": "oil",
        "name": "Cosrx AHA/BHA Clarifying Treatment Toner",
        "info": "Formulated with AHA, BHA and purifying botanical ingredients, the AHA/BHA Clarifying Treatment Toner works to soothe, refresh and soften the skin.",
        "ingredients": "Water, Salix Alba (Willow) Bark Water, Pyrus Malus (Apple) Fruit Water, Butylene Glycol, 1,2-Hexanediol, Sodium Lactate, Glycolic Acid, Betaine Salicylate, Allantoin, Panthenol, Ethyl Hexanediol",
        "image": "/images/toners/cosrx-toner.jpg",
        "price": 12.45,
        "qty": 1,
        "id": 25,
    },
    {
        "type": "toner",
        "skin_type": "dry",
        "name": "Pyungkang Yul Essence Toner",
        "info": "Pyunkang Yul Essence Toner is a viscous essence type toner that is deeply nourishing and revitalizes dry skin with its minimum essential ingredients. Only 7 healthy and necessary ingredients were added being inspired by Pyunkang Eastern Medicine Clinic, eliminating other ingredients with unproven chemicals effects that are used for artificial fragrance and colors in general cosmetics.",
        "ingredients": "Astragalus membranaceus root extract, 1,2-hexanediol, butylene glycol, bis-peg-18 methyl ether dimethyl silane, hydroxyethylcellulose, carbomer, arginine.",
        "image": "/images/toners/pi.jpg",
        "price": 16,
        "qty": 1,
        "id": 26,
    },
    // SERUMS
    {
        "type": "serum",
        "skin_type": "All skin types",
        "name": "missha Time Revolution Vitality Serum",
        "info": "Revitalizes skin stressed from harmful environmental factors, Silky texture gently absorbs into skin for a velvety smooth finish",
        "ingredients": "Red Complex - includes pomegranate, hibiscus, and cranberry for revitalizing energy DN-Aid - includes cassia alata extract, which has strong vital power even in tropical regions, to strengthen skin barrier Trilagen & Linseed - includes peptide complex trilagen and linseed ingredient for their synergistic effect",
        "image": "/images/serums/missha-serum.jpg",
        "price": 32,
        "qty": 1,
        "id": 30,
    },
    {
        "type": "serum",
        "skin_type": "All skin types",
        "name": "benton snail bee serum",
        "info": "Two powerhouse ingredients - snail mucin and bee venom - come together in this serum to provide a multitude of complexion-boosting benefits.",
        "ingredients": "Saccharomyces/Snail Secretion Filtrate Ferment Filtrate, Melaleuca Alternifolia (Tea Tree) Leaf Water, Aqua (Water), Camellia Sinensis Leaf Water, Butylene Glycol, 1,2-Hexanediol, Niacinamide, Glycerin, Pentylene Glycol, Aloe Barbadensis Leaf Juice Powder, Sodium Hyaluronate, Chamaecyparis Obtusa Leaf Extract, Diospyros Kaki Leaf Extract, Ulmus Campestris (Elm) Bark Extract, Plantago Asiatica Extract, Laminaria Digitata Extract, Salix Alba (Willow) Bark Extract, Aloe Barbadensis Leaf Extract, Althaea Rosea Root Extract, Allantoin, Adenosine, Bee Venom, Beta-Glucan, Betaine, Panthenol, Citric Acid, Caprylyl Glycol, Xanthan Gum",
        "image": "/images/serums/benton-serum.jpg",
        "price": 27,
        "qty": 1,
        "id": 31,
    },
    {
        "type": "serum",
        "skin_type": "sensitive",
        "name": "Mizon Snail Repair Intensive Ampoule",
        "info": "Containing over 80% snail secretion filtrate, this ampoule deeply delivers moisture while nourishing skin with hyaluronic acid and cacao tree extract.",
        "ingredients": "Water,Butylene Glycol,Snail Secretion Filtrate,Glycerin,Alcohol,Glycereth-26,Panthenol,Phenoxyethanol,Carbomer,Triethanolamine,1,2-Hexanediol,Trehalose,Ethylhexylglycerin,Sodium Polyacrylate,Adenosine,Punica Granatum Fruit Extract,SodiumHyaluronate,Dextrin,Disodium EDTA,Nelumbo Nucifera Flower Extract,Theobroma Cacao (Cocoa) Extract,Coptis Chinensis RootExtract,Palmitoyl Tripeptide-5,Copper Tripeptide-1,Vaccinium Macrocarpon (Cranberry) Fruit Extract,Rubus Idaeus (Raspberry) FruitExtract,Prunus Serotina (Wild Cherry) Fruit Extract,Cornus Officinalis Fruit Extract.",
        "image": "/images/serums/mizon-serum.jpg",
        "price": 17.12,
        "qty": 1,
        "id": 32,
    },
    {
        "type": "serum",
        "skin_type": "All skin types",
        "name": "cosrx Freshly Juiced Vitamin C Drop",
        "info": "An effective, innovative skin care serum that features 5% vitamin C (ascorbic acid) and is gentle enough for sensitive skin types! Vitamin C is an antioxidant that provides the best in anti-aging protection and is an effective brightening ingredient. This vitamin C serum has a pH level of 3.81",
        "ingredients": "Water, Propylen Glycol, Ascorbic Acid, Hydroxyethylcellulose, Centella Asiatica Extract, Citrus Junos Fruit Extract, Illicium Verum(Anise) Fruit Extract, Citrus Paradisi(Grapefruit) Fruit Extract, Nelumbium Speciosum Flower Extract, Paeonia Suffruticosa Root Extract, Scutellaria Baicalensis Root Extract, Polysorbate 60, Brassica Oleracea Italica (Broccoli) Extract, Chaenomeles Sinensis Fruit Extract, Citrus Aurantium Dulcis (Orange) Oil, Sodium Acrylate/Sodium Acryloyldimethyl Taurate Copolymer, Disodium EDTA, Lavandula Angustifolia (Lavender) Oil, Camellia Sinensis Callus Culture Extract, Larix Europaea Wood Extract, Chrysanthellum Indicum Extract, Rheum Palmatum Root Extract, Asarum Sieboldi Root Extract, Quercus Mongolia Leaf Extract, Persicaria Hydropiper Extract, Corydalis Turtschaninovii Root Extract, Coptis Chinensis Root Extract, Magnolia Obovata Bark Extract, Lysine HCL, Proline, Sodium Ascorbyl Phosphate, Acetyl Methionine, Theanine, Lecithin, Acetyl Glutamine, SH-Olgopeptide-1, SH-Olgopeptide-2, SH-Polypeptide-1, SH-Polypeptide-9, SH-Polypeptide-11, Bacillus/Soybean/Folic Acid Ferment Extract, Sodium Hyaluronate, Caprylyl Glycol, Butylene Glycol, 1,2-Hexanediol, Limonene",
        "image": "/images/serums/klairs-serum.jpg",
        "price": 23,
        "qty": 1,
        "id": 33,
    },
]
const list = [
    {   
        "name":"ზეთოვანი გაწმენდა",
        "content": "ღრმად ასუფთავებს კანს ჭუჭყისგან. შლის და აშორებს მაკიაჟს, მკვდარ უჯრედებს.",
        "image":"/images/oil-balm.jpg",
        "link-img":"",
        "id":1,
    },
    {
        "name":"წყალზე დამზადებული გამწმენდი",
        "content":"ორმაგი გაწმენდის მეორე ნაბიჯი წყალზე დამზადებული გამწმენდით სახის დაბანვაა. მასში შემავალი კომპონენტები ებრძვიან ჭუჭყისა და მიკრობების იმ ნაწილს, რომელიც ზეთოვანმა საშუალებამ ვერ მიიერთა.",
        "image":"",
        "link-img":"",
        "id":2,
    },
    {
        "name":"ექსფოლიატორი",
        "content":"ქიმიური და ფიზიკური ექსფოლიატორი ასუფთავებენ ფორებს, აშორებენ მკვდარ უჯრედებს, აუმჯობესებენ სისხლის მიმოქცევას და კანს ეხმარება უკეთ შეიწოვოს დამატენიანებელი საშუალებები",
        "image":"/images/scrab.jpg",
        "link-img":"",
        "id":3
    },
    {
        "name":"ტონერი",
        "content":"მისი საშუალებით კანის PH ბალანსს აღდგენა ხდება, შეავიწროვებს ფორებს და დაატენიანებს სახეს.",
        "image":"",
        "link-img":"",
        "id":4
    },
    {
        "name":"ესენცია",
        "content":"ის ტონერისა  და სერუმის შუა საფეხურია, რომელიც აღადგენს და ატენიანებს კანს.  ",
        "link-img":"",
        "image":"",
        "id":5
    },
    {
        "name":"სერუმი / შრატი / ამპულა ",
        "content":"შეიცავს აქტიურ ინგრედიენტებს, როგორიცაა ანტიოქსიდანტები, მჟავები და ვიტამინები. ხელს უწყობს კანში კოლაგენის გამომუშავებას და ტენიანობის შენარჩუნებას. ეწინააღმდეგება პიგმენტურ ლაქებს, კანის ფერის ასაკობრივ ცვლილებებს და ღრმა ნაოჭებს.",
        "image":"",
        "link-img":"",
        "id":6
    },
    {
        "name":"სახის ნიღბები",
        "content":"ქსოვილის ნიღბებს ერთ-ერთი მნიშვნელოვანი ადგილი უჭირავს სახის მოვლის კორეულ მეთოდში, შეიცავენ დიდი კონცენტრაციით მკვებავი აქტიური ნივთირებებით გაჯერებულ ესენციას, კანს ხდის უფრო გლუვსა და მბზინვარეს. კორეული სახის ნიღბები გამორჩეულია მრავალფეროვნებით და დიზაინითაც კი.",
        "image":"/images/masks.png",
        "link-img":"",
        "id":7
    },
    {
        "name":"თვალის კრემი",
        "content":"თვალის გარშემო კანი სახის ყველაზე თხელი და ნაზი ადგილია, რომელსაც რეგულარული მოვლა სჭირდება. თვალის კრემის რეგულარული გამოყენება თავიდან აგარიდებთ შავ წრეებს და შეშუპებას.",
        "image":"",
        "link-img":"",
        "id":8
    },
    {
        "name":"დამატენინებელი კრემი",
        "content":"კორეული სილამაზის ინდუსტრია ნებისმიერი გემოვნების კრემს გთავაზობთ.",
        "image":"",
        "link-img":"",
        "id":9
    },
    {
        "name":"მზის დამცავი",
        "content":"ბოლო საფეხური მზის დამცავია. მზის სხივები კანის დაბერებას იწვევს. წაისვით ყოველ დილით ქუჩაში გასვლამდე. კორეელები ირწმუნებიან: თუ გსურთ კანის ახალგაზრდობის შენარჩუნება, მზისგან დამცავ კრემებს დაუმეგობრდით.",
        "image":"",
        "link-img":"",
        "id":10
    }
]
const test_data = [
    {
        "question": "How does your skin feel?",
        "answers": [
            { "ans": "comfortable", "result": 1 },
            { "ans": "tight", "result": 2 },

        ],
    },
    {
        // if answers comfortable
        "question": "Is there residue on the tissue?",
        "answers": [
            { "ans": "no", "result": "normal" },
            { "ans": "yes", "result": false }
        ],
    },
    {
        "question": "Do your cheeks feel tight?",
        "answers": [
            { "ans": "no", "result": "oily" },
            { "ans": "yes", "result": 'combination' }
        ],

    },
    {
        // if skin is tight
        "question": "Is your skin itchy and inflamed?",
        "answers": [
            { "ans": "no", "result": "dry" },
            { "ans": "yes", "result": "sensitive" }
        ],
    }
] 

const onlineShopLinks=[
   
    {
        "link": "https://www.roseroseshop.com/", 
        "image":"/images/rose.jpg"
    },
    {
        "link":"https://www.amazon.com/Korean-Beauty/b?ie=UTF8&node=11585018011",
        "image":"/images/amazon.jpg"
    },
    {
        "link":"https://www.iherb.com/c/k-beauty",
        "image":"/images/iherb.png"
    },
    {
        "link":"https://www.yesstyle.com/en/korean-beauty-cosmetics",
        "image":"/images/yesstyle.jpeg"
    },
    {
        "link":"https://jolse.com/",
        "image":"/images/jolse.png"
    },
    {
        "link":"https://www.ebay.com/b/korea-cosmetic/bn_7024953399",
        "image":"/images/ebay.jpg"
    },
]
export { k_products, list, test_data, onlineShopLinks}